/* Sportster – eigenes Theme. Vanilla-JS ohne Framework.
   Teile: Menü (Mega + Handy), Blätter (Warenkorb, Filter), Warenkorb (Ajax + Section Rendering),
   Suche mit Vorschlägen, Fuß-Akkordeons. Seiten ohne JS bleiben benutzbar (Links, Formulare). */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var body = document.body;
  var desk = window.matchMedia('(min-width: 1000px)');
  var canHover = window.matchMedia('(hover: hover)').matches;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- Menüs ---------- */
  var kopf = $('#kopf'), burger = $('#burger'), mmenu = $('#mmenu');
  var megaTimer, offen = null;
  function setMega(id) {
    $$('.mega', kopf).forEach(function (m) { m.hidden = m.id !== id; });
    $$('[data-mega]', kopf).forEach(function (b) { b.setAttribute('aria-expanded', b.getAttribute('data-mega') === id ? 'true' : 'false'); });
    offen = id;
  }
  /* Handy-Menü: Schublade mit Ebenen (Variante A). Ebenen sind Geschwister in .mm-ebenen; der Pfad merkt sich den Weg. */
  var mmPfad = [], mmTimer, ruhig = window.matchMedia('(prefers-reduced-motion: reduce)');
  var dauer = function () { return ruhig.matches ? 0 : 300; };
  function mmZeige(neu, alt, vor) {
    neu.hidden = false;
    neu.classList.add(vor ? 'rein' : 'weg');
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      neu.classList.remove('rein', 'weg'); neu.classList.add('an');
      if (alt) { alt.classList.remove('an'); alt.classList.add(vor ? 'weg' : 'rein'); }
    }); });
    if (alt) setTimeout(function () { alt.hidden = true; alt.classList.remove('weg', 'rein'); }, dauer());
    var f = vor ? $('[data-mm-zurueck]', neu) : $('[data-mm-ebene="' + (alt && alt.id) + '"]', neu);
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, dauer());
  }
  function mmReset() {
    $$('.mm-ebene', mmenu).forEach(function (e) { var start = e.id === 'mm-0'; e.hidden = !start; e.classList.toggle('an', start); e.classList.remove('rein', 'weg'); e.scrollTop = 0; });
    mmPfad = [];
  }
  function setMobile(open) {
    if (!mmenu) return;
    clearTimeout(mmTimer);
    if (open === !mmenu.hidden && mmenu.classList.contains('an') === open) return;
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    burger.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
    body.classList.toggle('gesperrt', open);
    if (open) {
      mmReset(); mmenu.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { mmenu.classList.add('an'); }); });
      setTimeout(function () { var z = $('.mm-ebene.an .mm-zeile', mmenu); if (z) z.focus({ preventScroll: true }); }, dauer());
    } else {
      mmenu.classList.remove('an');
      mmTimer = setTimeout(function () { mmenu.hidden = true; }, dauer());
      if (mmenu.contains(document.activeElement)) burger.focus();
    }
  }
  if (mmenu) {
    mmenu.addEventListener('click', function (e) {
      var weiter = e.target.closest('[data-mm-ebene]');
      if (weiter) { var ziel = document.getElementById(weiter.getAttribute('data-mm-ebene')), akt = $('.mm-ebene.an', mmenu); if (ziel && akt) { mmPfad.push(akt.id); mmZeige(ziel, akt, true); } return; }
      if (e.target.closest('[data-mm-zurueck]')) { var zurueck = document.getElementById(mmPfad.pop() || 'mm-0'), jetzt = $('.mm-ebene.an', mmenu); if (zurueck && jetzt) mmZeige(zurueck, jetzt, false); return; }
      if (e.target.closest('[data-mm-zu]')) { setMobile(false); return; }
      if (e.target.closest('[data-mm-suche]')) { setMobile(false); if (typeof setSuche === 'function') setSuche(true); }
    });
    mmenu.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = $$('a[href],button:not([disabled])', mmenu).filter(function (n) { return n.offsetParent !== null && !n.closest('[hidden]'); });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }
  if (kopf) {
    $$('.nav-item--mega', kopf).forEach(function (item) {
      var link = $('[data-mega]', item), id = link.getAttribute('data-mega');
      item.addEventListener('mouseenter', function () { if (!canHover) return; clearTimeout(megaTimer); setMega(id); });
      link.addEventListener('click', function (e) {
        if (canHover && offen === id) return; /* zweiter Klick folgt dem Link */
        e.preventDefault(); setMega(offen === id ? null : id);
      });
      link.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); setMega(id); var a = $('#' + id + ' a'); if (a) a.focus(); }
      });
    });
    $$('.nav-item:not(.nav-item--mega)', kopf).forEach(function (n) { n.addEventListener('mouseenter', function () { setMega(null); }); });
    kopf.addEventListener('mouseleave', function () { if (!canHover) return; megaTimer = setTimeout(function () { setMega(null); }, 160); });
    kopf.addEventListener('mouseenter', function () { clearTimeout(megaTimer); });
    document.addEventListener('click', function (e) { if (offen && !e.target.closest('#kopf')) setMega(null); });
    if (burger) burger.addEventListener('click', function () { setMobile(!mmenu.classList.contains('an')); });
    var change = function () { setMega(null); setMobile(false); };
    desk.addEventListener ? desk.addEventListener('change', change) : desk.addListener(change);
  }

  /* ---------- Suche im Kopf mit Vorschlägen ---------- */
  var suche = $('#suche-overlay'), sucheAuf = $('[data-suche-auf]');
  function setSuche(open) {
    if (!suche) return;
    suche.hidden = !open;
    sucheAuf.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { setMega(null); var f = $('input[type="search"]', suche); setTimeout(function () { f.focus(); }, 30); }
  }
  if (sucheAuf) sucheAuf.addEventListener('click', function () { setSuche(suche.hidden); });
  var vTimer;
  $$('[data-vorschlag-feld]').forEach(function (feld) {
    var ziel = $('[data-vorschlag]', feld.closest('.suche-overlay') || document);
    feld.addEventListener('input', function () {
      clearTimeout(vTimer);
      var q = feld.value.trim();
      if (q.length < 2) { ziel.innerHTML = ''; return; }
      vTimer = setTimeout(function () {
        fetch(root + 'search/suggest?q=' + encodeURIComponent(q) + '&section_id=suche-vorschlag&resources[type]=product,collection,article&resources[limit]=6')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (t) {
            var d = new DOMParser().parseFromString(t, 'text/html');
            var inh = d.querySelector('[data-vorschlag-inhalt]');
            ziel.innerHTML = inh ? inh.innerHTML : '';
          }).catch(function () { ziel.innerHTML = ''; });
      }, 180);
    });
  });

  /* ---------- Blätter (Warenkorb, Filter) ---------- */
  var scrim = $('#scrim'), openEl = null, lastFocus = null;
  function openBlatt(el) {
    if (!el) return;
    if (openEl && openEl !== el) closeBlatt(true);
    setMobile(false); setMega(null);
    lastFocus = document.activeElement; openEl = el;
    el.classList.add('an'); el.setAttribute('aria-hidden', 'false');
    scrim.classList.add('an'); body.classList.add('gesperrt');
    var f = $('[data-zu]', el); if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeBlatt(keepScrim) {
    if (!openEl) return;
    openEl.classList.remove('an'); openEl.setAttribute('aria-hidden', 'true'); openEl = null;
    if (!keepScrim) { scrim.classList.remove('an'); body.classList.remove('gesperrt'); }
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) { /* egal */ } }
  }
  if (scrim) scrim.addEventListener('click', function () { closeBlatt(); });
  document.addEventListener('click', function (e) {
    var zu = e.target.closest('[data-zu]'); if (zu && openEl && openEl.contains(zu)) { e.preventDefault(); closeBlatt(); }
    var auf = e.target.closest('[data-blatt]'); if (auf) { e.preventDefault(); openBlatt(document.getElementById(auf.getAttribute('data-blatt'))); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (openEl) closeBlatt();
      else if (suche && !suche.hidden) setSuche(false);
      else { setMega(null); setMobile(false); }
    }
    if (e.key === 'Tab' && openEl) {
      var f = $$('a[href],button:not([disabled]),input:not([disabled]),select,[tabindex]:not([tabindex="-1"])', openEl).filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Warenkorb ---------- */
  function warenkorbEl() { return $('[data-warenkorb]'); }
  function zahlSetzen(n) { $$('[data-cart-n]').forEach(function (z) { z.textContent = n; }); }
  function neuLaden(html) {
    var alt = warenkorbEl(); if (!alt) return;
    var d = new DOMParser().parseFromString(html, 'text/html');
    var neu = d.querySelector('[data-warenkorb]'); if (!neu) return;
    var war = alt.classList.contains('an');
    var f = document.activeElement, fKey = null, fArt = null;
    if (f && alt.contains(f)) {
      var li = f.closest('[data-key]'); fKey = li && li.getAttribute('data-key');
      fArt = f.classList.contains('ci-weg') ? 'weg' : (f.getAttribute('aria-label') || '');
    }
    alt.innerHTML = neu.innerHTML;
    if (fKey !== null || fArt) {
      var ziel = null, zeile = fKey && alt.querySelector('[data-key="' + fKey + '"]');
      if (zeile) ziel = fArt === 'weg' ? zeile.querySelector('.ci-weg') : zeile.querySelector('[aria-label="' + fArt + '"]');
      (ziel || alt.querySelector('[data-zu]')).focus();
    }
    if (war) { alt.classList.add('an'); alt.setAttribute('aria-hidden', 'false'); }
    var z = $('[data-cart-n]', alt); if (z) zahlSetzen(z.textContent);
  }
  function postJson(url, daten) {
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(daten) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  window.SP = window.SP || {};
  SP.warenkorb = {
    oeffnen: function () { openBlatt(warenkorbEl()); },
    hinzufuegen: function (items) {
      return postJson('cart/add.js', { items: items, sections: 'warenkorb-leiste' }).then(function (j) {
        if (j.sections) neuLaden(j.sections['warenkorb-leiste']);
        SP.warenkorb.oeffnen(); return j;
      });
    },
    aendern: function (key, menge) {
      return postJson('cart/change.js', { id: key, quantity: menge, sections: 'warenkorb-leiste' }).then(function (j) {
        if (j.sections) neuLaden(j.sections['warenkorb-leiste']);
        if (document.body.classList.contains('vorlage-cart')) location.reload();
        return j;
      });
    }
  };
  document.addEventListener('click', function (e) {
    var auf = e.target.closest('[data-warenkorb-auf]');
    if (auf && !document.body.classList.contains('vorlage-cart')) { e.preventDefault(); SP.warenkorb.oeffnen(); return; }
    var m = e.target.closest('[data-warenkorb] [data-menge]');
    if (m) {
      e.preventDefault(); var li = m.closest('[data-key]'); if (!li) return;
      li.style.opacity = '.5';
      SP.warenkorb.aendern(li.getAttribute('data-key'), parseInt(m.getAttribute('data-menge'), 10)).catch(function (err) { li.style.opacity = ''; alert(err && err.description || 'Das hat nicht geklappt.'); });
    }
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-schnellkauf], form[data-kaufen]');
    if (!f) return;
    e.preventDefault();
    var fd = new FormData(f), knopf = $('[type="submit"]', f);
    if (knopf) { knopf.disabled = true; knopf.setAttribute('aria-busy', 'true'); }
    SP.warenkorb.hinzufuegen([{ id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) }])
      .catch(function (err) { alert(err && err.description || 'Das Produkt konnte nicht in den Warenkorb gelegt werden.'); })
      .then(function () { if (knopf) { knopf.disabled = false; knopf.removeAttribute('aria-busy'); } });
  });

  /* ---------- Fuß-Akkordeons: mobil zu, ab Tablet offen ---------- */
  var tab = window.matchMedia('(min-width: 750px)');
  function fussAkk() { $$('.foot-akk').forEach(function (d) { d.open = tab.matches; }); }
  fussAkk(); tab.addEventListener ? tab.addEventListener('change', fussAkk) : tab.addListener(fussAkk);

  /* ---------- Kategorie: Sortierung sofort, leere Preisfelder weglassen, Text einklappen ---------- */
  $$('[data-sortierung] select').forEach(function (sel) { sel.addEventListener('change', function () { sel.form.submit(); }); });
  $$('[data-filter-form]').forEach(function (f) {
    f.addEventListener('submit', function () { $$('input', f).forEach(function (i) { if ((i.type === 'number' || i.type === 'text') && !i.value) i.disabled = true; }); });
  });
  $$('[data-einklappen]').forEach(function (box) {
    var knopf = box.parentNode.querySelector('[data-einklappen-knopf]');
    if (!knopf || box.scrollHeight < 320) return;
    box.classList.add('ist-zu'); knopf.hidden = false;
    knopf.addEventListener('click', function () {
      var zu = box.classList.toggle('ist-zu'); knopf.setAttribute('aria-expanded', zu ? 'false' : 'true');
    });
  });
  var kMehr = $('.k-mehr');
  if (kMehr) kMehr.addEventListener('click', function () { var b = $('[data-einklappen]'); var k = $('[data-einklappen-knopf]'); if (b && b.classList.contains('ist-zu')) { b.classList.remove('ist-zu'); if (k) k.setAttribute('aria-expanded', 'true'); } });


  /* ---------- Produktseite ---------- */
  var pdp = $('[data-produkt]');
  if (pdp) {
    var varianten = JSON.parse(($('[data-varianten]') || {}).textContent || '[]');
    var daten = JSON.parse(($('[data-produkt-daten]') || {}).textContent || '{}');
    var idFeld = $('[data-variante]', pdp);
    var haupt = $('#g-haupt');
    var auswahl = varianten.length ? (varianten.find(function (x) { return String(x.id) === idFeld.value; }) || varianten[0]).options.slice() : [];
    var passend = function () { return varianten.find(function (x) { return x.options.every(function (o, i) { return o === auswahl[i]; }); }); };
    function bildZeigen(mediaId) {
      var t = mediaId && $('.thumb[data-media="' + mediaId + '"]', pdp);
      if (!t || !haupt) return;
      haupt.src = t.getAttribute('data-bild'); haupt.srcset = t.getAttribute('data-srcset'); haupt.alt = t.getAttribute('data-alt');
      $$('.thumb', pdp).forEach(function (b) { b.setAttribute('aria-current', b === t ? 'true' : 'false'); });
    }
    function status(x) {
      var el = $('[data-status]', pdp); if (!el) return;
      if (!x || !x.available) el.innerHTML = '<span class="status-punkt status--aus"></span> Ausverkauft';
      else if (x.menge !== null && x.menge > 0 && x.menge <= (daten.schwelle || 10)) el.innerHTML = '<span class="status-punkt status--wenig"></span> Nur noch ' + x.menge + ' auf Lager';
      else el.innerHTML = '<svg class="ic status-ok" aria-hidden="true" focusable="false"><use href="#i-check"/></svg> Auf Lager';
    }
    function anwenden(url_setzen) {
      var x = passend();
      $$('.sorte', pdp).forEach(function (b) {
        var i = +b.getAttribute('data-option'), w = b.getAttribute('data-wert');
        b.setAttribute('aria-pressed', auswahl[i] === w ? 'true' : 'false');
        var probe = auswahl.slice(); probe[i] = w;
        var gibt = varianten.some(function (y) { return y.available && y.options.every(function (o, k) { return o === probe[k]; }); });
        b.classList.toggle('sorte--leer', !gibt);
      });
      $$('[data-option-name]', pdp).forEach(function (n) { n.textContent = auswahl[+n.getAttribute('data-option-name')]; });
      var knopf = $('[data-kaufknopf]', pdp), text = $('[data-kaufknopf-text]', pdp), leiste = $('[data-kaufleiste-knopf]');
      if (!x) { knopf.disabled = true; text.textContent = 'Nicht erhältlich'; if (leiste) leiste.disabled = true; status(null); return; }
      idFeld.value = x.id;
      $$('[data-preis]').forEach(function (p) { p.textContent = x.preis.replace(/&nbsp;/g, ' '); });
      var alt = $('[data-preis-alt]', pdp); alt.hidden = !x.alt; alt.textContent = x.alt.replace(/&nbsp;/g, ' ');
      var gp = $('[data-grundpreis]', pdp); gp.hidden = !x.gp; $('span', gp).textContent = x.gp.replace(/&nbsp;/g, ' ');
      var gk = $('[data-grundpreis-kurz]'); if (gk) gk.textContent = x.gp.replace(/&nbsp;/g, ' ');
      var flag = $('[data-sale-flag]', pdp); if (flag) { flag.hidden = !x.prozent; flag.textContent = '−' + x.prozent + ' %'; }
      knopf.disabled = !x.available; text.textContent = x.available ? 'In den Warenkorb' : 'Ausverkauft'; if (leiste) leiste.disabled = !x.available;
      status(x); bildZeigen(x.media);
      var lz = $('[data-lieferzeit]', pdp); if (lz) lz.hidden = !x.available;
      document.dispatchEvent(new CustomEvent('variant:update', { detail: { resource: { id: x.id, price: x.cent } } }));
      if (url_setzen) { var url = new URL(location.href); url.searchParams.set('variant', x.id); history.replaceState(null, '', url); }
    }
    $$('.sorte', pdp).forEach(function (b) {
      b.addEventListener('click', function () {
        var i = +b.getAttribute('data-option'), w = b.getAttribute('data-wert');
        auswahl[i] = w;
        if (!passend()) {
          var ersatz = varianten.find(function (y) { return y.available && y.options[i] === w; }) || varianten.find(function (y) { return y.options[i] === w; });
          if (ersatz) auswahl = ersatz.options.slice();
        }
        anwenden(true);
      });
    });
    if (varianten.length > 1) anwenden(false);
    $$('.thumb', pdp).forEach(function (t) { t.addEventListener('click', function () { bildZeigen(t.getAttribute('data-media')); }); });
    var zahl = $('.stepper-zahl', pdp);
    $$('[data-menge-schritt]', pdp).forEach(function (b) {
      b.addEventListener('click', function () { zahl.value = Math.max(1, (parseInt(zahl.value, 10) || 1) + parseInt(b.getAttribute('data-menge-schritt'), 10)); });
    });
    var leisteEl = $('#kaufleiste'), zeile = $('#kauf-zeile'), leisteKnopf = $('[data-kaufleiste-knopf]');
    if (leisteEl && zeile && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        var zeigen = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
        leisteEl.classList.toggle('zeigen', zeigen); leisteEl.setAttribute('aria-hidden', zeigen ? 'false' : 'true');
        leisteKnopf.tabIndex = zeigen ? 0 : -1;
      }).observe(zeile);
      leisteKnopf.addEventListener('click', function () { var f = $('form[data-kaufen]', pdp); if (f.requestSubmit) f.requestSubmit(); else f.submit(); });
    }
  }
  var empf = $('[data-empfehlungen]');
  if (empf) {
    fetch(empf.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (t) {
      var d = new DOMParser().parseFromString(t, 'text/html'); var n = d.querySelector('[data-empfehlungen]');
      if (n && n.querySelector('.pk')) empf.innerHTML = n.innerHTML;
    }).catch(function () {});
  }

  SP.$ = $; SP.$$ = $$; SP.openBlatt = openBlatt; SP.closeBlatt = closeBlatt;
})();
